import angular from 'angular';

export default angular
  .module('csm.ui.csmFocus', [])

  /**
   * @ngdoc    directive
   * @module   csm.ui
   * @restrict A
   * @name     csm.ui.csmFocus.directive:csmFocus
   * @param    {Object}    csmFocus      Object to check to determine when to set focus
   *                                     on the element. The object will be updated when
   *                                     focus is lost.
   * @param    {Attribute} selectOnFocus Marker attribute that when present indicates
   *                                     that on focus, all existing text will be selected.
   *
   * @description
   * Attribute directive that can be used to toggle focus on the element.
   *****************************************************************************/
  .directive('csmFocus', function ($timeout) {
    /** Body JQLite Reference. */
    var $body = angular.element(document.getElementsByTagName('body')[0]);

    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        /** Element has focus. */ var mHasFocus = false;
        /** Select all text on focus. */ var mSelectOnFocus =
          attr.selectOnFocus != undefined;
        /** Body watch deregister function. */ var mBodyWatch = null;
        /** Focus expression watch deregister function. */ var mFocusWatch =
          null;

        /*----------------------------------------------------------*/
        /* Set up event listeners when a property has been provided */
        /*----------------------------------------------------------*/
        if (['true', 'false', ''].indexOf(attr.csmFocus) == -1) {
          element.on('blur', function () {
            setValue(false);
          });
          element.on('focus', function () {
            setValue(true);
          });
        }

        /** Sets the internal value and updates the expression variable. */
        function setValue(val) {
          mHasFocus = val;

          /*----------------------------------------------*/
          /* Call the select method on focus if requested */
          /*----------------------------------------------*/
          if (val && mSelectOnFocus && element[0].select) element[0].select();

          /*-----------------------------------------*/
          /* Update the provided expression variable */
          /*-----------------------------------------*/
          $timeout(function () {
            scope.$apply('{0}={1}'.format(attr.csmFocus, val));
          });
        }

        /*-------------------------------------*/
        /* Ensure the element is part of the   */
        /* DOM before watching the expression. */
        /*-------------------------------------*/
        mBodyWatch = scope.$watch(
          function () {
            return $body[0].contains(element[0]);
          },
          function (inDOM) {
            if (inDOM) {
              mBodyWatch();
              mBodyWatch = null;

              /*----------------------------------------*/
              /* Watch the expression for value changes */
              /*----------------------------------------*/
              mFocusWatch = scope.$watch(attr.csmFocus, function (shouldFocus) {
                if (shouldFocus && !mHasFocus)
                  $timeout(function () {
                    element[0].focus();
                  });
              });
            }
          }
        );

        /*-----------------------------------------------*/
        /* Clean up watchers when the element is removed */
        /*-----------------------------------------------*/
        element.on('$destroy', function () {
          if (mBodyWatch) mBodyWatch();
          if (mFocusWatch) mFocusWatch();
        });
      }
    };
  })
  .name;
